<template>
  <section class="vehicle-detail-page">
    <AppPageTitleBar
      :title="route.meta.title"
      :back-to="{ name: 'inventory-vehicles' }"
      back-label="Natrag"
    />

    <div
      v-if="vehicle"
      class="page-stack grid-stack grid-gap-page-section"
    >
      <section class="page-panel">
        <header class="page-panel__header page-panel__header--with-action">
          <h3 class="lead-text ma-0">Osnovni podaci</h3>

          <v-btn
            v-if="!vehicle.isArchived"
            class="button button--secondary button--small text-uppercase"
            :to="vehicleEditRoute"
            variant="outlined"
          >
            Uredi vozilo
          </v-btn>
        </header>

        <div class="page-panel__content grid grid-row-gap-20 grid-column-gap-24">
          <div
            v-for="vehicleDetail in vehicleDetails"
            :key="vehicleDetail.label"
            class="col-12 col-sm-6"
          >
            <p class="vehicle-detail-page__label">
              {{ vehicleDetail.label }}
              <span class="vehicle-detail-page__required">*</span>
            </p>
            <p class="vehicle-detail-page__value">{{ vehicleDetail.value }}</p>
          </div>

          <p
            v-if="!vehicle.isActive"
            class="notice col-12"
          >
            Vozilo neće biti dostupno za rezervacije dok se status ručno ne promijeni nazad u „Aktivno”.
          </p>
        </div>
      </section>

      <VehicleUsageHistory :vehicle-id="route.params.vehicleId" />
    </div>
  </section>
</template>

<script setup>
import { useRoute } from 'vue-router'

import AppPageTitleBar from '../../components/AppPageTitleBar.vue'
import VehicleUsageHistory from '../../components/VehicleUsageHistory.vue'
import { getEventBrandName, vehiclePurposeOptions } from '../../helpers'

const route = useRoute()
const vehicle = window.history.state?.vehicle ?? null
const vehicleEditRoute = {
  name: 'inventory-vehicle-edit',
  params: { vehicleId: route.params.vehicleId },
  state: { vehicle },
}
const vehicleDetails = vehicle
  ? [
      { label: 'Marka', value: getEventBrandName(vehicle.brandCode) },
      { label: 'Tip vozila', value: vehicle.name },
      { label: 'Registracijska oznaka', value: vehicle.plate },
      { label: 'Broj šasije', value: vehicle.vin },
      { label: 'Boja', value: vehicle.color },
      { label: 'Vrsta korištenja', value: vehicle.isForDrive ? 'Vozni park' : 'Događaji' },
      ...(vehicle.isForDrive
        ? [{
            label: 'Namjena',
            value: vehiclePurposeOptions.find(({ value }) => value === vehicle.purpose)?.title ?? '-',
          }]
        : []),
      { label: 'Status', value: vehicle.isActive ? 'Aktivno' : 'Neispravno' },
    ]
  : []
</script>

<style
  scoped
  lang="scss"
>
.vehicle-detail-page {
  &__label,
  &__value {
    color: var(--color-black);
  }

  &__label {
    margin: 0;
    font-size: clamp-bp("sm", "xl", 13, 14);
    font-weight: 500;
    line-height: clamp-bp("sm", "xl", 18, 20);
  }

  &__value {
    margin: 4px 0 0;
    font-size: clamp-bp("sm", "xl", 14, 15);
    font-weight: 300;
    line-height: clamp-bp("sm", "xl", 20, 22);
  }

  &__required {
    color: var(--color-danger);
  }
}
</style>
